import { createContext, useContext } from "react";

/** Langue de la page client (proposition publique) : "fr" (défaut) ou "en". Le back-office reste en français. */
export const LangContext = createContext("fr");
export const useLang = () => useContext(LangContext);

/** tr("Signer", "Sign") : le texte dans la langue de la proposition (français par défaut). */
export const makeTr = (lang) => (fr, en) => (lang === "en" ? en : fr);
export const useTr = () => makeTr(useContext(LangContext));

/** Locale des dates (et montants) de la page client. */
export const dateLocale = (lang) => (lang === "en" ? "en-GB" : "fr-FR");
